import { ACCESS_STATES } from 'core/contexts/locations/location.constants';
import * as VM from 'core/contexts/locations/location.model';
import * as ByUserModel from './location-by-user.api';
import * as Model from './location.api';

export const mapLocationFromApiToVm = (data: Model.Location): VM.Location => ({
    id: data.id,
    name: data.name,
    pocOperationsId: data.pocOperationsId,
    children: data.childrenLocations?.map((child) => mapChildrenLocationFromApiToVm(child, data.id, data.name)) ?? [],
    parentLocation: data.parentLocation,
});

export const mapChildrenLocationFromApiToVm = (data: Model.ChildrenLocationApi, id: string, name: string) => ({
    ...data,
    parentLocation: {
        id,
        name,
    },
});

export const mapListedLocationFromApiToVm = (data: ByUserModel.ListedLocationApi): VM.Location => ({
    id: data.id,
    name: data.name,
    pocOperationsId: data.pocOperationsId,
    children: data.childrenLocations?.map((child) => mapChildrenLocationFromApiToVm(child, data.id, data.name)) ?? [],
    parentLocation: null,
});

/** Falls back to FULL so an unknown wire value never renders the "contact your administrator" state. */
export const toAccessState = (raw: string): VM.AccessState =>
    (ACCESS_STATES as readonly string[]).includes(raw) ? (raw as VM.AccessState) : 'FULL';
